import i18n from '../config/i18n';
import { normalizeLanguageCode } from '../config/normalizeLanguageCode';
import { languageService } from '../services/languageService';
import {
  markLanguageChoice,
  pickLanguageForMarket,
  readLanguageChoice,
} from './marketLanguage';

/**
 * Applique la langue profil (API ou login) sur i18n + localStorage.
 * Si le serveur n'a pas de préférence, on conserve le localStorage
 * (et on le propage au serveur quand possible).
 *
 * @param force - Si true (ex. login), le serveur gagne même si le local diffère.
 *   Sans force : si le local diffère du serveur, on garde le local (évite qu'un
 *   get-profile tardif avec DEFAULT fr écrase un choix utilisateur).
 */
export function applyUserPreferredLanguage(
  pref: string | undefined | null,
  options?: { force?: boolean },
): void {
  const serverLang = normalizeLanguageCode(pref);
  const localLang = languageService.getLocalLanguage();
  const force = options?.force === true;

  if (serverLang) {
    if (!force && localLang && localLang !== serverLang) {
      const current = normalizeLanguageCode(i18n.language);
      if (current !== localLang) {
        void i18n.changeLanguage(localLang);
      }
      if (localStorage.getItem('token')) {
        void languageService.syncToBackend(localLang);
      }
      return;
    }

    const current = normalizeLanguageCode(i18n.language);
    if (current !== serverLang) {
      void i18n.changeLanguage(serverLang);
    }
    localStorage.setItem('preferredLanguage', serverLang);
    return;
  }

  if (localLang && localStorage.getItem('token')) {
    void languageService.syncToBackend(localLang);
  }
}

/**
 * Compte BE/NL sans choix explicite et sans langue serveur autre que le défaut fr :
 * nl navigateur → nl-BE (BE) ou nl-NL (NL), de → de.
 */
export function maybeApplyMarketLanguage(
  country: string | null | undefined,
  preferred: string | null | undefined,
): void {
  if (readLanguageChoice() === 'explicit') return;
  const server = normalizeLanguageCode(preferred);
  if (server && server !== 'fr') return;
  const languages =
    typeof navigator !== 'undefined' && navigator.languages?.length
      ? navigator.languages
      : [typeof navigator !== 'undefined' ? navigator.language : 'fr'];
  const picked = pickLanguageForMarket(country, languages);
  if (!picked || picked === server) return;
  markLanguageChoice('auto');
  languageService.setLocalLanguage(picked);
  if (normalizeLanguageCode(i18n.language) !== picked) {
    void i18n.changeLanguage(picked);
  }
  if (localStorage.getItem('token')) {
    void languageService.syncToBackend(picked);
  }
}
